function initAccordion(accordion) {
  if (accordion.dataset.accordionInitialized === 'true') return;

  const accordionToggle = accordion.querySelector('.accordion-toggle');
  const accordionContent = accordion.querySelector('.accordion-content');

  // Content may be injected later (e.g. product-recommendations fetches its
  // markup after page load). Bail out quietly until both parts exist; the
  // loader re-runs initAccordions() once the content is in place.
  if (!accordionToggle || !accordionContent) return;

  accordion.dataset.accordionInitialized = 'true';

  accordionToggle.addEventListener('click', () => {
    const expanded = accordion.classList.toggle('accordion--expanded');
    accordionContent.setAttribute('data-expanded', expanded);
  });
}

function initAccordions(root = document) {
  if (root instanceof Element && root.classList.contains('accordion')) {
    initAccordion(root);
  }
  root.querySelectorAll('.accordion').forEach(initAccordion);
}

window.initAccordions = initAccordions;

initAccordions();
